// extra interface that can cause circle dependency
export interface IDashboardExtraIcon {
  classes:string;
  legend:string;
}

export const ICONS:IDashboardExtraIcon[] = [
  {
    classes: 'fa fa-check-circle table-ok-icon checklists-status-legend',
    legend: 'OK'
  },
  {
    classes: 'fa fa-exclamation-circle table-warning-icon checklists-status-legend',
    legend: 'Optional, not yet completed.'
  },
  {
    classes: 'fa fa-exclamation-circle table-error-icon checklists-status-legend',
    legend: 'Mandatory, not yet completed.'
  }
];